(function () {
  if (!customElements.get('keystone-public-buy')) {
    customElements.define('keystone-public-buy', class extends HTMLElement {
      connectedCallback() {
        this.onChange = () => this.updateVariant();
        this.onClick = event => {
          const thumb = event.target.closest('[data-image]');
          if (!thumb) return;
          const main = this.querySelector('[data-main-image]');
          main.src = thumb.dataset.image;
          main.alt = thumb.dataset.alt;
          this.querySelectorAll('[data-image]').forEach(button => button.setAttribute('aria-pressed', String(button === thumb)));
        };
        this.addEventListener('change', this.onChange);
        this.addEventListener('click', this.onClick);
        const notice = this.querySelector('[data-instagram-help]');
        if (notice) notice.hidden = !/Instagram|FBAN|FBAV|FB_IAB|FBIOS/i.test(navigator.userAgent || '');
        this.updateVariant();
      }
      disconnectedCallback() {
        this.removeEventListener('change', this.onChange);
        this.removeEventListener('click', this.onClick);
      }
      updateVariant() {
        const select = this.querySelector('[data-variant]');
        if (!select) return;
        const option = select.selectedOptions[0];
        ['price', 'was', 'saving'].forEach(key => {
          const el = this.querySelector('.ksj-buy__prices [data-' + key + ']');
          el.innerHTML = option.dataset[key] || '';
          el.hidden = !option.dataset[key];
        });
        const available = option.dataset.available === 'true';
        const button = this.querySelector('[data-add]');
        button.disabled = !available;
        button.textContent = available ? 'Add to cart' : 'Currently unavailable';
        this.querySelector('[data-unavailable]').hidden = available;
      }
    });
  }
  if (!customElements.get('keystone-lesson')) {
    customElements.define('keystone-lesson', class extends HTMLElement {
      connectedCallback() {
        this.paint = () => {
          const release = Date.parse(this.dataset.release);
          const due = !Number.isFinite(release) || Date.now() >= release;
          const ready = due && this.dataset.hasLink === 'true';
          const link = this.querySelector('[data-lesson-link]');
          const wait = this.querySelector('[data-lesson-wait]');
          if (link) link.hidden = !ready;
          wait.hidden = ready;
          if (due && this.dataset.release && !ready) wait.textContent = 'Video link coming soon';
        };
        this.paint();
        this.timer = setInterval(this.paint, 15000);
      }
      disconnectedCallback() { clearInterval(this.timer); }
    });
  }
})();
